import React from "react";
import { prepPrimaryRouter } from "app/PrimaryRouter";
import { Nav } from "app/Nav";
import { prepSetNavConfig } from "app/navConfig";
import { GlobalStyle } from "core/styles";
import { ScrollToTop } from "core/components/ScrollToTop";
import { prepErrorPage } from "pages/error";
import { getPreppedPrimaryRouteMatcher } from "./getPreppedPrimaryRouteMatcher";
import { useFocusScroll } from "core/customHooks/useFocusScroll";
export var App = function (_a) {
    var appState = _a.appState, detailsController = _a.detailsController, headController = _a.headController;
    var primaryRouteMatcher = getPreppedPrimaryRouteMatcher(detailsController, headController);
    var setNavConfig = prepSetNavConfig(detailsController);
    var Router = prepPrimaryRouter(primaryRouteMatcher, Nav, setNavConfig, prepErrorPage(setNavConfig, detailsController));
    // Initialize focus scroll behavior
    useFocusScroll();
    return (React.createElement(React.Fragment, null,
        React.createElement(ScrollToTop, null),
        React.createElement(GlobalStyle, null),
        React.createElement(Router, { appState: appState })));
};
